var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.28852 8.15305C1.06643 7.93095 0.928775 7.62442 0.929932 7.28549C0.929932 6.60764 1.47823 6.05934 2.15608 6.05934L13.2424 6.05934C13.9202 6.05934 14.4685 6.60763 14.4685 7.28549C14.4685 7.96334 13.9202 8.51164 13.2424 8.51164L2.15608 8.51164C1.81716 8.5128 1.51062 8.37515 1.28852 8.15305Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.70a7869c56755fe9a3ea93628881a795.svg";
export { ForwardRef as ReactComponent };